import { Avatar } from "./Avatar";

export function AvatarButton({ user, handleClick, big=false }) {
  
  return (
    <button
      onClick={handleClick}
      className="cursor-pointer flex items-center space-x-2 focus:outline-none" 
    >
      <Avatar user={user} big={big}/>
    </button >
  );
}